import { ref } from 'vue'

export const messages = {
  'en': {
    message: {
      title: 'Tung Tung Tung Sahur Escape Game',
      start: 'Click to start the game!',
      continue: 'Keep clicking!',
      careful: 'Be careful...',
      danger: 'Danger level increased!',
      veryDanger: 'Very dangerous!',
      critical: 'Critical situation!',
      caught: 'You got caught!',
      escaped: 'Successfully escaped!',
      share: 'Share Result',
      retry: 'Try Again',
      distracted: 'Sahur is distracted... Quick, click now!',
      missed: 'Missed the chance...'
    }
  },
  'zh-TW': {
    message: {
      title: 'Tung Tung Tung Sahur 逃脫遊戲',
      start: '點擊開始遊戲！',
      continue: '繼續點擊！',
      careful: '小心一點...',
      danger: '危險程度提高了！',
      veryDanger: '非常危險！',
      critical: '命懸一線！',
      caught: '你被抓到了！',
      escaped: '逃脫成功！',
      share: '分享結果',
      retry: '再試一次',
      distracted: 'Sahur 分心了... 趕快點擊！',
      missed: '錯過了機會...'
    }
  },
  'ja': {
    message: {
      title: 'トン トン トン サフル脱出ゲーム',
      start: 'クリックしてゲームを開始！',
      continue: 'クリックし続けて！',
      careful: '気をつけて...',
      danger: '危険レベル上昇！',
      veryDanger: '非常に危険！',
      critical: '危機的状況！',
      caught: '捕まってしまった！',
      escaped: '脱出成功！',
      share: '結果を共有',
      retry: '再挑戦',
      distracted: 'サフルが気を散らしている...今すぐクリック！',
      missed: 'チャンスを逃した...'
    }
  },
  'ko': {
    message: {
      title: '퉁 퉁 퉁 사후르 탈출 게임',
      start: '클릭해서 게임 시작!',
      continue: '계속 클릭하세요!',
      careful: '조심하세요...',
      danger: '위험 레벨 증가!',
      veryDanger: '매우 위험!',
      critical: '위기 상황!',
      caught: '잡혔습니다!',
      escaped: '탈출 성공!',
      share: '결과 공유',
      retry: '다시 시도',
      distracted: '사후르가 방심하고 있어요... 지금 클릭하세요!',
      missed: '기회를 놓쳤어요...'
    }
  },
  'id': {
    message: {
      title: 'Game Melarikan Diri Tung Tung Tung Sahur',
      start: 'Klik untuk memulai permainan!',
      continue: 'Terus klik!',
      careful: 'Hati-hati...',
      danger: 'Tingkat bahaya meningkat!',
      veryDanger: 'Sangat berbahaya!',
      critical: 'Situasi kritis!',
      caught: 'Kamu tertangkap!',
      escaped: 'Berhasil melarikan diri!',
      share: 'Bagikan Hasil',
      retry: 'Coba Lagi',
      distracted: 'Sahur terganggu... Cepat, klik sekarang!',
      missed: 'Kehilangan kesempatan...'
    }
  },
  'es': {
    message: {
      title: 'Juego de Escape Tung Tung Tung Sahur',
      start: '¡Haz clic para comenzar el juego!',
      continue: '¡Sigue haciendo clic!',
      careful: 'Ten cuidado...',
      danger: '¡Nivel de peligro aumentado!',
      veryDanger: '¡Muy peligroso!',
      critical: '¡Situación crítica!',
      caught: '¡Te atraparon!',
      escaped: '¡Escapaste con éxito!',
      share: 'Compartir Resultado',
      retry: 'Intentar de Nuevo',
      distracted: 'Sahur está distraído... ¡Haz clic ahora!',
      missed: 'Perdiste la oportunidad...'
    }
  },
  'de': {
    message: {
      title: 'Tung Tung TungSahur Fluchtspiel',
      start: 'Klicken Sie, um das Spiel zu starten!',
      continue: 'Weiterklicken!',
      careful: 'Vorsichtig...',
      danger: 'Gefahrenstufe erhöht!',
      veryDanger: 'Sehr gefährlich!',
      critical: 'Kritische Situation!',
      caught: 'Du wurdest erwischt!',
      escaped: 'Erfolgreich entkommen!',
      share: 'Ergebnis teilen',
      retry: 'Nochmal versuchen',
      distracted: 'Sahur ist abgelenkt... Schnell, jetzt klicken!',
      missed: 'Chance verpasst...'
    }
  },
  'ar': {
    message: {
      title: 'لعبة الهروب تونج تونج تونج ساحور',
      start: 'انقر لبدء اللعبة!',
      continue: 'استمر في النقر!',
      careful: 'كن حذرًا...',
      danger: 'زاد مستوى الخطر!',
      veryDanger: 'خطير جدًا!',
      critical: 'وضع حرج!',
      caught: 'لقد تم القبض عليك!',
      escaped: 'هروب ناجح!',
      share: 'مشاركة النتيجة',
      retry: 'حاول مرة أخرى',
      distracted: 'ساحور مشتت... انقر الآن بسرعة!',
      missed: 'فقدت الفرصة...'
    }
  }
}

export const currentLanguage = ref('en')

export function setLanguage(lang) {
  currentLanguage.value = lang
}

export function t(key) {
  return messages[currentLanguage.value].message[key]
}